import { render } from "./index.vue?vue&type=template&id=7c041be0&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=7c041be0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\EDZ\\Desktop\\emulator\\linux_app_emulator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c041be0"]])

export default __exports__